<template>
  <div class="guide">
    <van-swipe ref="swiper" @change="onChange" :stop-propagation="false" vertical :show-indicators="false" :loop="false">
      <template v-for="item in bg_img_list" :key="item">
        <van-swipe-item>
          <div class="img-box animate__animated">
            
            <div class="p8" v-show="index == 8">
                <img class="p8-img" :src="p8_img_list[0]" alt="">
                <img class="p8-img" :src="p8_img_list[1]" @click="showVideo(0)" alt="">
                <img class="p8-img" :src="p8_img_list[2]" @click="showVideo(1)" alt="">
                <img class="p8-img" :src="p8_img_list[3]" @click="showVideo(2)" alt="">
                <img class="p8-img" :src="p8_img_list[4]" @click="showVideo(3)" alt="">
                <img class="p8-img" :src="p8_img_list[5]" @click="showVideo(4)" alt="">
                <img class="p8-img" :src="p8_img_list[6]" @click="showVideo(5)" alt="">
                <img class="p8-img" :src="p8_img_list[7]" alt="">
            </div>
            <img class="item-bg-img" :src="item" alt="" v-show="index != 8"/>
          </div>
        </van-swipe-item>
      </template>
    </van-swipe>
    <div class="paging-icon paging-icon--absolute paging-up" @click="toNextPage" v-show="swiper_index"> </div>
    <div class="paging-icon paging-icon--absolute paging-down" @click="toPrevPage" v-show="!swiper_index"> </div>
    <div class="" v-if="show">
      <div class="close-btn" @click="show = false">关闭</div>
      <van-dialog v-model:show="show" title="" width="100%" @close="close" :overlayStyle="{background: 'rgba(0, 0, 0, 1)'}" :showConfirmButton="false" :close-on-click-overlay="true">
        <!-- <iframe v-if="showIframe" ref="myframe" style="width: 100%; height: 320px;" :src="video_list[urlIndex].url" frameborder="0"></iframe> -->
        <div v-if="showIframe" >
          <video class="video" :poster='video_list[urlIndex].url + "?vframe/jpg/offset/0"' :src="video_list[urlIndex].url" x5-video-player-type="h5" webkit-playsinline="true" x-webkit-airplay="true" x5-video-orientation="portraint" playsInline="true" x5-video-player-fullscreen="portraint" x5-video-ignore-metadata='true' autoplay muted controls></video>
        </div>
      </van-dialog> 
      <!-- <iframe ref="myframe" style="width: 100%; height: 320px;" :src="video_list[urlIndex].url" frameborder="0"></iframe> -->
    </div>
  </div>
</template>
<script>
import { reactive, onMounted, ref, inject } from "vue";
import { getShareCon } from "../api/share";
export default {
  name: "guidepage",
  setup() {
    const bg_img_list = reactive([
      require("../assets/images/h5_P1.jpg"),
      require("../assets/images/h5_P2.jpg"),
      require("../assets/images/h5_P3.jpg"),
      require("../assets/images/h5_P4.jpg"),
      require("../assets/images/h5_P5.jpg"),
      require("../assets/images/h5_P15.jpg"),
      require("../assets/images/h5_P6.jpg"),
      require("../assets/images/h5_P7.jpg"),
      require("../assets/images/h5_P8.png"),
      require("../assets/images/h5_P9.jpg"),
      require("../assets/images/h5_P10.jpg"),
      require("../assets/images/h5_P11.jpg"),
      require("../assets/images/h5_P12.jpg"),
      require("../assets/images/h5_P13.jpg"),
      require("../assets/images/h5_P14.jpg"),
    ]);
    const p8_img_list = reactive([
      require("../assets/images/p8_1.png"),
      require("../assets/images/p8_2.png"),
      require("../assets/images/p8_3.png"),
      require("../assets/images/p8_4.png"),
      require("../assets/images/p8_5.png"),
      require("../assets/images/p8_6.png"),
      require("../assets/images/p8_7.png"),
      require("../assets/images/p8_8.png"),
    ])
    const show = ref(false);
    const showIframe = ref(true);
    const video_list = ref([
      {
        title: "种草官",
        url: "https://resource.xmy.club/wxsmall/images/zcg.m4V"
      },
      {
        title: "享童行",
        url: "https://resource.xmy.club/wxsmall/images/xtx.mp4"
      },
      {
        title: "享定制",
        url: "https://resource.xmy.club/wxsmall/images/xdz.m4v"
      },
      {
        title: "旅行IP",
        url: "https://resource.xmy.club/wxsmall/images/xbl.m4v"
      },
      {
        title: "享游达人",
        url: "https://resource.xmy.club/wxsmall/images/xdr.m4v"
      },
      {
        title: "标准产品",
        url: "https://resource.xmy.club/wxsmall/images/xbz.mp4"
      }
    ]);
    console.log(video_list)
    const swiper_index = ref(true)
    const index =  ref(0)
    const urlIndex = ref(0)
    const { getShareContentFun } = getShareCon()
    document.addEventListener("touchstart", getShareContentFun, false);
    document.addEventListener("WeixinJSBridgeReady", getShareContentFun, false);
    // iframe样式
    const iframe = ref(null);
    // const modifyIframeStyle = () => {
    //   const iframeDocument = iframe.value.contentDocument || iframe.value.contentWindow.document;
    //   const styleElement = iframeDocument.createElement('style');
    //   styleElement.textContent = 'body { background-color: transparent; }';
    //   iframeDocument.head.appendChild(styleElement);
    // };
    //父组件的方法
    const changeOn = inject('changeOn')
    onMounted(() => {
      // modifyIframeStyle()
    });
    const animateList = ref([
      'animate__backInLeft',
      'animate__backInUp',
      'animate__backInRight',
      'animate__backInDown',
      'animate__fadeIn',
      'animate__fadeInUp',
      'animate__fadeInDown',
      "animate__bounceInDown",
      "animate__bounceInLeft",
      "animate__bounceInRight",
      "animate__bounceInUp",
      "animate__bounceInDown",
      "animate__flash",
      'animate__lightSpeedInRight',
      'animate__lightSpeedInLeft',
      'animate__rubberBand',
      'animate__shakeX',
      'animate__shakeY',
      'animate__headShake',
      "animate__zoomIn",
      "animate__zoomInUp",
      "animate__zoomInDown",
      "animate__zoomInLeft",
      "animate__zoomInRight",
      "animate__rotateIn",
      "animate__rotateInDownLeft",
      "animate__rotateInDownRight",
      "animate__rotateInUpLeft",
      "animate__rotateInUpRight",
      "animate__hinge",
      "animate__jackInTheBox",
      "animate__jackInTheScreenLeft",
      "animate__jackInTheScreenRight",
      "animate__jackInTheScreenTop",
      "animate__jackInTheScreenBottom",
      "animate__rollIn",
      "animate__rotateIn",
      "animate__slideInDown",
      "animate__slideInLeft",
      "animate__slideInRight",
    ]);
    const swiper = ref(null)
    const toNextPage = () =>{
      swiper.value.next()
    }
    const toPrevPage = () =>{
      swiper.value.prev()
    }
    const  getRandom = () => {
      return Math.floor( Math.random() * (41) )
    };
    const  onChange = (e) => {
    //  console.log(e, bg_img_list.length,e < bg_img_list.length - 1)
      index.value = e;
      swiper_index.value = e < bg_img_list.length - 1;
    };
    const close = () => { 
      changeOn('on')
      showIframe.value = false
    }
    const showVideo = (e) => {
      // modifyIframeStyle();
      changeOn('off')
      showIframe.value = true
      show.value = true;
      urlIndex.value = e;
      
    };
    return {
      bg_img_list,
      toNextPage,
      toPrevPage,
      swiper,
      getRandom,
      animateList,
      onChange,
      swiper_index,
      index,
      show,
      video_list,
      p8_img_list,
      showVideo,
      urlIndex,
      iframe,
      showIframe,
      close
    };
  },
};
</script>

<style lang="stylus">
.img-box {
    width: 100%;
    height: 100%;
}
.item-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
}
.van-swipe__indicators {
  bottom: 100px;

  .van-swipe__indicator {
    width: 12px;
    height: 12px;
  }

  .van-swipe__indicator--active {
    width: 40px;
    background: #fff;
    border-radius: 6px;
  }
}
.van-popup {
  background: transparent;
}
.p8-img {
  width: 100%
  height: auto;
  display: block;
  vertical-align: top;
  margin-top: -1px
}
.van-swipe {
  height: 100vh;
}

.paging-icon {
  position: absolute;
  left: 50%;
  margin-left: -50px;
  z-index: 4;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: reverse;
  -ms-flex-direction: column-reverse;
  flex-direction: column-reverse;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100px;
  height: 100px;
  cursor: pointer;
}
.paging-up {
  bottom: 20px;
  -webkit-animation: slide-next-page 1.5s linear infinite;
  animation: slide-next-page 1.5s linear infinite;
}
.paging-up:after, .paging-up:before{
    content: "";
    width: 16px;
    height: 16px;
    -webkit-box-shadow: 4px -4px 2px 4px rgba(0 0 0 0.08);
    box-shadow: 4px -4px 1px 4px rgba(0 0 0 0.08);
    border-color: #fff;
    border-style: solid;
    border-width: 8px 8px 0 0;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
}
.paging-down {
  top: 20px;
  -webkit-animation: slide-prev-page 1.5s linear infinite;
  animation: slide-prev-page 1.5s linear infinite;
}
.paging-down:after, .paging-down:before{
  content: "";
  width: 16px;
  height: 16px;
  -webkit-box-shadow: -4px 4px 2px 4px rgba(0 0 0 0.08);
  box-shadow: -4px 4px 1px 4px rgba(0 0 0 0.08);
  border-color: #fff;
  border-style: solid;
  border-width: 0 0 8px 8px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.paging-icon:before {
  margin-top: 3px;
  border-color: rgba(255, 255, 255, 0.3);
}
@keyframes slide-next-page {
  0% {
    -webkit-transform: translateY(-20px);
    transform: translateY(-20px);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateY(-36px);
    transform: translateY(-36px);
    opacity: 0;
  }
}
@-webkit-keyframes slide-next-page {
  0% {
    -webkit-transform: translateY(-20px);
    transform: translateY(-20px);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateY(-36px);
    transform: translateY(-36px);
    opacity: 0;
  }
}

@keyframes slide-prev-page {
  0% {
    -webkit-transform: translateY(6px);
    transform: translateY(6px);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateY(16px);
    transform: translateY(16px);
    opacity: 0;
  }
}
@-webkit-keyframes slide-prev-page {
  0% {
    -webkit-transform: translateY(6px);
    transform: translateY(6px);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateY(16px);
    transform: translateY(16px);
    opacity: 0;
  }
}
.video {
  width 100%;
  height: auto
}
.close-btn {
  position: fixed;
  right: 20px;
  top: 20px;
  z-index: 99999;
  cursor: pointer;
  font-size: 20px;
  color: #fff;
}
</style>
